import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/base/BackToTop";
import Breadcrumb from "@/components/base/Breadcrumb";
import FaqAccordion from "@/pages/faq/components/FaqAccordion";
import { usePageMeta } from "@/hooks/usePageMeta";
import { faqs } from "@/mocks/faqs";
import { categories } from "@/mocks/categories";

export default function Faq() {
  usePageMeta({
    title: "常见问题｜黑料今日日报更新、栏目与订阅答疑",
    description:
      "关于黑料今日的常见问题解答：日报更新频率、每日更新栏目如何划分、如何只订阅某个栏目、信息从哪来、如何反馈与取消订阅等，一页看完。",
    keywords: "黑料今日常见问题,日报更新时间,每日更新栏目,栏目订阅,取消订阅",
    path: "/faq",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: "https://043r0.cn/" },
          { "@type": "ListItem", position: 2, name: "常见问题", item: "https://043r0.cn/faq" },
        ],
      },
    ],
  });

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <section className="px-4 md:px-8 pt-8 md:pt-10 pb-8 bg-background-100 border-b border-background-200">
          <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "常见问题" }]} />
          <h1 className="mt-4 font-heading font-black text-3xl md:text-4xl text-foreground-950">
            常见问题
          </h1>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-3xl leading-relaxed">
            关于日报更新节奏、栏目划分与订阅方式，这里汇总了读者问得最多的几个问题。
            如果没有找到答案，欢迎来信。
          </p>
        </section>

        <section className="px-4 md:px-8 py-10 md:py-14">
          <div className="grid lg:grid-cols-12 gap-10">
            <div className="lg:col-span-8">
              <FaqAccordion items={faqs} />
            </div>

            <aside className="lg:col-span-4">
              <div className="lg:sticky lg:top-28 space-y-5">
                <div className="rounded-lg border border-background-200 bg-background-50 p-5">
                  <h2 className="font-heading font-bold text-lg text-foreground-950">还没解决？</h2>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    直接来信说明你的问题，我们会在三个工作日内回复。
                  </p>
                  <a
                    href="mailto:heyliao@example.com"
                    className="mt-4 flex items-center gap-3 px-4 py-3 rounded-md bg-background-100 border border-background-200 hover:border-primary-300 transition-colors"
                  >
                    <i className="ri-mail-line text-lg text-primary-600" />
                    <span className="text-sm text-foreground-800">heyliao@example.com</span>
                  </a>
                  <Link
                    to="/daily"
                    className="mt-3 flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-newspaper-line" />
                    去读今日日报
                  </Link>
                </div>

                <div className="rounded-lg border border-background-200 bg-background-50 p-5">
                  <h2 className="font-heading font-bold text-lg text-foreground-950">热门栏目</h2>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {categories.map((cat) => (
                      <Link
                        key={cat.id}
                        to={`/daily?cat=${cat.id}`}
                        className="px-3 py-1.5 rounded-md bg-secondary-100 text-secondary-900 text-xs hover:bg-secondary-200 transition-colors cursor-pointer"
                      >
                        {cat.name}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}